import React from 'react'
import { Link } from 'react-router-dom'

// Public tools catalog. Add new public tools here as they become available.
const TOOLS = [
  {
    key: 'background-removal',
    name: 'Background Removal',
    description:
      'Remove image backgrounds instantly with AI. Upload a photo and download a clean PNG with a transparent background.',
    icon: '🪄',
    to: '/tools/bgr',
    available: true,
  },
]

const ToolsLandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  VideoEditor
                </h1>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <a
                href="/"
                className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Home
              </a>
              <a
                href="/dashboard"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
              >
                Dashboard
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <div className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Free Online Tools</h2>
          <p className="text-xl text-gray-600">
            A collection of powerful tools you can use right now. No sign-up required.
          </p>
        </div>
      </div>

      {/* Tools grid */}
      <div className="pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {TOOLS.map((tool) => (
              <Link
                key={tool.key}
                to={tool.to}
                className="group bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex flex-col"
              >
                <div className="text-5xl mb-4">{tool.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                  {tool.name}
                </h3>
                <p className="text-gray-600 flex-1">{tool.description}</p>
                <span className="mt-6 inline-flex items-center text-blue-600 font-medium">
                  Open tool
                  <svg
                    className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-2">
            VideoEditor
          </h3>
          <p className="text-gray-400">Powerful, free tools powered by AI</p>
          <div className="mt-4 text-sm text-gray-500">
            &copy; 2025 VideoEditor. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  )
}

export default ToolsLandingPage
